import SubordinatesWorkloadConstants from '@/store/modules/subordinatesWorkload/constants';
import SubordinatesWorkloadService from '@/services/subordinatesWorkloadService';

const subordinatesWorkloadService = new SubordinatesWorkloadService();

export default {
  [SubordinatesWorkloadConstants.actionTypes.loadClients]({
    commit,
  }) {
    commit(SubordinatesWorkloadConstants.mutationTypes.setSubordinatesClientsLoading, true);

    subordinatesWorkloadService.loadClients()
      .then((clients) => {
        commit(SubordinatesWorkloadConstants.mutationTypes
          .setSubordinatesClients, clients);
      })
      .finally(() => {
        commit(SubordinatesWorkloadConstants.mutationTypes.setSubordinatesClientsLoading, false);
      });
  },

  [SubordinatesWorkloadConstants.actionTypes.loadSubordinates]({
    commit,
    dispatch,
    state,
  }, paginationData) {
    commit(SubordinatesWorkloadConstants.mutationTypes.setSubrodinatesLoading, true);

    subordinatesWorkloadService.loadSubordinates(paginationData)
      .then((subordinatesPaged) => {
        commit(SubordinatesWorkloadConstants.mutationTypes
          .setSubordinates, subordinatesPaged.items);

        commit(SubordinatesWorkloadConstants.mutationTypes
          .setSubordinatesTotal, subordinatesPaged.total);


        if (!state.selectedSubordinateId
            && subordinatesPaged.items
            && subordinatesPaged.items.length !== 0) {
          dispatch(SubordinatesWorkloadConstants.actionTypes
            .selectSubordinate, subordinatesPaged.items[0].id);
        }
      })
      .finally(() => {
        commit(SubordinatesWorkloadConstants.mutationTypes.setSubrodinatesLoading, false);
      });
  },

  [SubordinatesWorkloadConstants.actionTypes.selectSubordinate]({
    commit,
    dispatch,
  }, subordinateId) {
    commit(SubordinatesWorkloadConstants.mutationTypes.setSelectedSubordinateId, subordinateId);

    dispatch(SubordinatesWorkloadConstants.actionTypes.loadSubordinateInfo);
  },

  [SubordinatesWorkloadConstants.actionTypes.loadSubordinateInfo]({ commit, state }) {
    if (state.selectedSubordinateId === null) {
      commit(SubordinatesWorkloadConstants.mutationTypes.setSubordinateInfo, null);
      return Promise.resolve();
    }

    commit(SubordinatesWorkloadConstants.mutationTypes.setSubordinateInfo, null);
    commit(SubordinatesWorkloadConstants.mutationTypes.setSubrodinateInfoLoading, true);

    return subordinatesWorkloadService.loadSubordinateInfo(state.selectedSubordinateId)
      .then((info) => {
        commit(SubordinatesWorkloadConstants.mutationTypes.setSubordinateInfo, info);

        return Promise.resolve();
      })
      .finally(() => {
        commit(SubordinatesWorkloadConstants.mutationTypes.setSubrodinateInfoLoading, false);
      });
  },

  [SubordinatesWorkloadConstants.actionTypes.updateSubordinateSubscription]({
    commit,
    state,
  }, payload) {
    commit(SubordinatesWorkloadConstants.mutationTypes.setUpdatingSubordinateSubscription, true);

    const { userId, isSubscribed } = payload;

    return subordinatesWorkloadService.updateSubscription(userId, isSubscribed)
      .then(() => {
        const { selectedSubordinateInfo, selectedSubordinateId } = state;

        if (selectedSubordinateId === userId) {
          selectedSubordinateInfo.notifyManager = isSubscribed;

          commit(SubordinatesWorkloadConstants.mutationTypes.setSubordinateInfo,
            state.selectedSubordinateInfo);
        }

        return Promise.resolve();
      })
      .finally(() => {
        commit(SubordinatesWorkloadConstants
          .mutationTypes.setUpdatingSubordinateSubscription, false);
      });
  },
  [SubordinatesWorkloadConstants.actionTypes.updateSideBarVisibility]({
    commit,
  }, visible) {
    commit(SubordinatesWorkloadConstants.mutationTypes.setShowSideBar, visible);
  },
};
